import { User } from "../context/AuthContext"
import { Device } from "../context/DeviceContext"
import { System, SystemDevice } from "../context/SystemContext"
import { getDevicesInSystem } from "./deviceHelper"

// const getDevicesInSystem = async (environment:any, user:User) => {
//     if(environment instanceof Object && '_id' in environment){
//         const response = await fetch(`${getBackendUrl()}/api/devices/inSystem/` + environment.name , {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${user.token}`
//             }
//         }) 
//         const json = await response.json()
//         if (response.ok){
//             return json
//         }
// //     }
// }



const checkForPhSystem = async (devices:any) => {
    let phSensorExists  = false
    let phPumpExists = false
    let sensors:any = []
    let pumps:any = []
    let pumpsInfo:any = []
    devices.map((device:any) => {
        if (device.device_type === 'pH Sensor'){
            phSensorExists = true
            sensors.push(device)
        }
        
        if ((device instanceof Object && 'roles' in device) && device.device_type.includes('Pump')){
            device.roles.map((role:any) =>{
                console.log("test", device.roles)
                if(role.role.includes("pH")){
                   phPumpExists = true 
                   pumps.push(device)
                   pumpsInfo.push({'device_id':device.device_id,'role': role.role ,'role_number':role.pump})
                }
            })
            
        }
    })
    if(phPumpExists && phSensorExists){
        return {'status': true, 'variable': 'pH' ,'sensors': sensors, 'controllers':pumps, 'controllers_info': pumpsInfo}
    }
    else{
        return {'status':false}
    }
}
const checkForEcSystem = async (devices:any) => {
    console.log("devices", devices)
    let ecSensorExists  = false
    let ecPumpExists = false
    let sensors:any = []
    let pumps:any = []
    let pumpsInfo:any = []
    devices.map((device:any) => {
        if (device.device_type === 'EC Sensor'){
            ecSensorExists = true
            sensors.push(device)
        }
        if ((device instanceof Object && 'roles' in device) && device.device_type.includes('Pump')){
            console.log('kjldasdhldsajkhlaksdjksa')
            device.roles.map((role:any) =>{
                console.log("test", device.roles)
                if(role.role.includes("A")|| role.role.includes("B") || role.role.includes("C") || role.role.includes("Water")){
                    console.log('ec pump')
                    ecPumpExists = true 
                    pumps.push(device)
                    pumpsInfo.push({'device_id':device.device_id,'role': role.role ,'role_number':role.pump})
                }
            })
            
        }
    })
    console.log("pumps", sensors)
    if(ecPumpExists && ecSensorExists){
        return {'status': true, 'variable': 'EC', 'sensors': sensors, 'controllers': Array.from(new Set(pumps)), 'controllers_info': pumpsInfo}
    }
    else{
        return {'status':false}
    }
}
const checkForTemperatureSystem = async (devices:any) => {
    let tempSensorExists  = false
    let fanExists = false
    let sensors:any = []
    let controllers:any = []
    let controllersInfo:any = []
    devices.map((device:any) => {
        if (device.device_type === 'Temperature Sensor'){
            tempSensorExists = true
            sensors.push(device)
        }
        if (device.device_type.includes('Outlet')){
            device.roles.map((role:any)=>{
                if (role.role.includes('Fan')){
                    fanExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id,'role': role.role, 'role_number':role.outlet})
                }  
                if (role.role.includes('AC')){
                    fanExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }  
                if (role.role.includes('Heater')){
                    fanExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }
                
            })
        }
        
    })
    if(tempSensorExists && fanExists){
        return {'status': true, 'variable': 'Temperature','sensors': sensors, 'controllers':controllers, 'controllers_info': controllersInfo}
    }
    else{
        return {'status':false}
    }
}
const checkForHumiditySystem = async (devices:any) => {
    let humiditySensorExists  = false
    let humidifierExists = false
    let fanExists = false
    let sensors:any = []
    let controllers:any = []
    let controllersInfo:any = []
    devices.map((device:any) => {
        if (device.device_type === 'Humidity Sensor'){
            humiditySensorExists = true
            sensors.push(device)
        }
        if (device.device_type.includes('Outlet')){
            device.roles.map((role:any)=>{
                if (role.role.includes('Humidifier')){
                    humidifierExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }
                if (role.role.includes('Exhaust Fan')){
                    fanExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }  
                if (!role.role.includes('Exhaust') && role.role.includes('Fan')){
                    fanExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                } 
                if (role.role.includes('Dehumidifier')){
                    humidifierExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }
            })
        }
        
    })
    if(humiditySensorExists && (humidifierExists || fanExists)){
        return {'status': true, 'variable': 'Humidity','sensors': sensors, 'controllers':controllers, 'controllers_info': controllersInfo}
    }
    else{
        return {'status':false}
    }
    
}

const checkForMoistureSystem = async (devices:any) => {
    let moistureSensorExists  = false
    let waterPumpExists = false
    let sensors:any = []
    let pumps:any = []
    devices.map((device:any) => {
        if (device.device_type === 'Soil Moisture Sensor'){
            moistureSensorExists = true
            sensors.push(device)
        }
        if (device.device_type.includes('Pump')){
            waterPumpExists = true
            pumps.push(device)
        }
    })
    if(waterPumpExists && moistureSensorExists){
        return {'status': true, 'variable': 'Moisture', 'sensors': sensors, 'controllers':pumps}
    }
    else{
        return {'status': false}
    }
}

export const checkForCirculatingPumps = async (devices:any) => {
    let circulatingPumpExists  = false
    let controllers:any = []
    let controllersInfo:any = []
    devices.map((device:any) => {
        if (device.device_type.includes('Outlet')){
            device.roles.map((role:any) =>{
                if(role.role.includes('Pump')){
                    circulatingPumpExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }
            })
        }
    })
    if(circulatingPumpExists){
        return {'status': true, 'variable': 'Water Circulation', 'controllers':controllers, 'controllers_info': controllersInfo}
    }
    else{
        return {'status': false}
    }
}

export const checkForLights = async (devices:any) => {
    let lightExists  = false
    let controllers:any = []
    let controllersInfo:any = []
    devices.map((device:any) => {
        if (device.device_type.includes('Outlet')){
            device.roles.map((role:any) =>{
                if(role.role.includes('Light')){
                    lightExists = true
                    controllers.push(device)
                    controllersInfo.push({'device_id':device.device_id, 'role': role.role, 'role_number':role.outlet})
                }
            })
        }
    })
    if(lightExists){
        return {'status': true, 'variable': 'Lights', 'controllers':controllers, 'controllers_info': controllersInfo}
    }
    else{
        return {'status': false}
    }
}

export const getPumpsAndOutlets = async (environment: { _id: string }, user: User) => {
    const devices = (await getDevicesInSystem(user, environment._id)) ?? []
    let pumps:any = []
    devices.map((device: any) => {
        if (device.device_type?.includes('Pump')) {
            pumps.push(device)
        }
    })
    let outlets: any = []
    devices.map((device: any) => {
        if (device.device_type?.includes('Outlet')) {
            outlets.push(device)
        }
    })
    return [pumps, outlets]
} 

// export const getOutlets = async (environment, user) => {
//     const devices = await getDevicesInSystem(environment, user)
//     let outlets = []
//     devices.map((device) =>{
//         if(device.device_type.includes('Outlet')){
//             outlets.push(device)
//         }
//     })
//     return outlets
// }

export const checkForCompleteSystems = async (environment:System, user:User) => {
    console.log('environment', environment)
    const devices = await getDevicesInSystem(user, environment._id)
    console.log('devices', devices)
    let completedSystems = []
    let ecSystem = await checkForEcSystem(devices)
    let phSystem = await checkForPhSystem(devices)
    let tempSystem = await checkForTemperatureSystem(devices)
    let humiditySystem = await checkForHumiditySystem(devices)
    let moistureSystem = await checkForMoistureSystem(devices)
    let circulatingPumps = await checkForCirculatingPumps(devices)
    let lights = await checkForLights(devices)
    if(ecSystem.status === true){
        completedSystems.push(ecSystem)
    }
    if(phSystem.status === true){
        completedSystems.push(phSystem)
    }
    if(tempSystem.status === true){
        completedSystems.push(tempSystem)
    }
    if(humiditySystem.status === true){
        completedSystems.push(humiditySystem)
    }
    if(moistureSystem.status === true){
        completedSystems.push(moistureSystem)
    }
    if(circulatingPumps.status === true){
        completedSystems.push(circulatingPumps)
    }
    if(lights.status === true){
        completedSystems.push(lights)
    }
    console.log("completedSystems", completedSystems)
    return completedSystems
}